import React from 'react';
import Modal from 'antd/lib/modal';
import { hideMessage } from '@codex/app-ducks/actions';
import classNames from 'classnames';
import { store } from '@codex/store/index';
var AppModal = function (props) {
    var _a;
    var Component = props.Component, isOpen = props.isOpen;
    return (React.createElement(Modal, { className: classNames((_a = {}, _a[props.classes.root] = true, _a[props.classes.withoutFooter] = true, _a)), visible: isOpen, onCancel: props.closeDialog, afterClose: function () { return store.dispatch(hideMessage()); }, footer: [] },
        React.createElement(Component, null)));
};
export default AppModal;



//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.tsx
// module id = 1337
// module chunks = 0